import React from 'react'
import { AddPublishScheduleArea } from '../../components'

interface IPackPublishOptionsFragment {
  disableAddPublishSchedule: boolean
}

export const PackPublishOptionsFragment = ({
  disableAddPublishSchedule,
}: IPackPublishOptionsFragment) => (
  <>
    <AddPublishScheduleArea
      disableAddPublishSchedule={disableAddPublishSchedule}
      publishTab
    />
  </>
)
